import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, Calendar, Clock, AlertCircle, ArrowRight, XCircle, Check, X } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ConfirmationPage() {
  const [showSurvey, setShowSurvey] = useState(false);
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    // Load Wistia embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/3w8fg500m8.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia styles
    const style = document.createElement('style');
    style.textContent = `wistia-player[media-id='3w8fg500m8']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3w8fg500m8/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(style);
    // Load GHL form embed script
    const formScript = document.createElement('script');
    formScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formScript.async = true;
    document.head.appendChild(formScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
      if (document.head.contains(formScript)) document.head.removeChild(formScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-1668" data-mp="2l4bf8c6gn5ul">
      {/* Progress Bar / Top Indicator */}
      <div className="w-full bg-gray-900 border-b border-gray-800" data-id="element-1669" data-mp="19q7kv4vynfp0">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between text-sm font-medium text-gray-400" data-id="element-1670" data-mp="19rip15tbipgn">
          <div className="flex items-center gap-2 text-[#7FFF00]" data-id="element-1671" data-mp="37drvrozix151">
            <CheckCircle2 className="w-5 h-5" data-id="element-1672" data-mp="37ejs520y32wd" />
            <span data-id="element-1673" data-mp="32mrwid2xm6zd">Compra Exitosa</span>
          </div>
          <div className="flex items-center gap-2 text-[#7FFF00]" data-id="element-1674" data-mp="32l8jqwghie2c">
            <span className="w-6 h-6 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center text-xs font-bold" data-id="element-1675" data-mp="2xmx9ikma21jl">
              2
            </span>
            <span data-id="element-1676" data-mp="2omqxl36899mj">Siguiente: Implementación</span>
          </div>
        </div>
      </div>

      <main className="max-w-5xl mx-auto px-4 py-8 md:py-16" data-id="element-1677" data-mp="2jnxhd2zk34io">
        {/* HERO SECTION */}
        <section className="text-center mb-8 md:mb-12 space-y-8" data-id="element-1678" data-mp="2ep485mraxzob">
          <div className="space-y-4" data-id="element-1679" data-mp="2eqxc2uaj65sm">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#7FFF00]/20 border border-[#7FFF00]/50 rounded-full px-4 py-2 mb-4" data-id="element-1680" data-mp="hvrh0942xtjs">
              <CheckCircle2 className="w-4 h-4 text-[#7FFF00]" data-id="element-1681" data-mp="cyivbyjq37ds" />
              <span className="text-sm font-semibold text-[#7FFF00]" data-id="element-1682" data-mp="ldozzulw12zl">
                Pago Confirmado
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight max-w-4xl mx-auto" data-id="element-1683" data-mp="pe8t8n3cbmgg">
              Pago confirmado. <br data-id="element-1684" data-mp="z6530vesh10i" />
              <span className="text-[#7FFF00]" data-id="element-1685" data-mp="z6ellxxi85w6">Paso 1 completado.</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1686" data-mp="2ge0c8wcg7jm">
              Ya tienes acceso al sistema. Ahora vamos a asegurarnos de que lo
              implementes correctamente y sin perder tiempo.
            </p>
          </div>

          {/* VIDEO EMBED */}
          <div className="max-w-4xl mx-auto space-y-6" data-id="element-1687" data-mp="gfdlv7ok86bk">
            <div className="relative" data-id="element-1688" data-mp="ggykp9hwqbf8">
              {/* Neon green gradient shadow */}
              <div className="absolute -inset-2 bg-gradient-to-r from-[#7FFF00] via-[#6FEF00] to-[#7FFF00] opacity-75 blur-2xl" data-id="element-1689" data-mp="1mv7j3ytrylsw"></div>

              <div className="relative aspect-video bg-gray-900 border border-[#7FFF00]/50 overflow-hidden shadow-2xl" data-id="element-1690" data-mp="30rr3c10o4e01">
                <wistia-player media-id="3w8fg500m8" aspect="1.7777777777777777" className="w-full h-full" data-id="element-1691" data-mp="2vt7dhpiyei2e"></wistia-player>
              </div>
            </div>

            {/* Support Disclaimer */}
            <div className="bg-gray-900/60 border border-gray-700 rounded-xl p-5 md:p-6 text-left space-y-3" data-id="element-1692" data-mp="34suggfrbzvxk">
              <p className="text-white font-bold text-base md:text-lg" data-id="element-1693" data-mp="3jptkjtmz56na">
                ¿Necesitás ayuda con acceso o soporte?
              </p>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-1694" data-mp="3epfol9yndn5m">
                📩 Para dudas técnicas, acceso, login o facturación:{' '}
                <br className="md:hidden" data-id="element-1695" data-mp="3oh3bqyo68i1a" />
                👉 Escribí a soporte aquí:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] underline transition-colors" data-id="element-1696" data-mp="6axb2spxtfem">
                  support@truemarketer.com
                </a>
              </p>
              <p className="text-yellow-400 text-sm font-semibold" data-id="element-1697" data-mp="kzgr7wofgyja">
                Este call es únicamente para evaluar el programa VIP.
              </p>
            </div>

            <div data-id="element-1698" data-mp="b0ra464cvi43">
              <button onClick={() => setShowSurvey(true)} className="block w-full bg-gradient-to-b from-[#7FFF00] to-[#6FEF00] hover:from-[#6FEF00] hover:to-[#5FDF00] text-black font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#7FFF00]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1699" data-mp="az7umhqixb3d">
                <span className="flex items-center justify-center gap-3" data-id="element-1700" data-mp="707h9eqtf0nr">
                  APLICAR PARA LA LLAMADA VIP
                  <ArrowRight className="w-5 h-5" data-id="element-1701" data-mp="3odb6b76kxn61" />
                </span>
              </button>
              <p className="text-center text-yellow-400 text-sm font-medium mt-3" data-id="element-1702" data-mp="3tc4nb9l2rway">
                ⚠️ Solo para alumnos listos para avanzar al siguiente nivel.
                Cupos limitados.
              </p>
            </div>
          </div>
        </section>

        {/* VALIDATION SECTION */}
        <section className="max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-1703" data-mp="1pzf4dp5g29kd">
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-8 md:p-10" data-id="element-1704" data-mp="1l5kjiie3rojp">
            <div className="flex gap-4 items-start" data-id="element-1705" data-mp="1g8kemaszoru6">
              <AlertCircle className="w-6 h-6 text-yellow-500 shrink-0 mt-1" data-id="element-1706" data-mp="1b8fy4ks2zx3y" />
              <div className="space-y-4" data-id="element-1707" data-mp="1b6cxz7x7snli">
                <h2 className="text-xl font-bold text-white" data-id="element-1708" data-mp="28wq0j0vs4mvl">
                  Muy importante que leas esto:
                </h2>
                <p className="text-gray-300 leading-relaxed" data-id="element-1709" data-mp="23yeocji0i0a7">
                  La mayoría de las personas que compran un programa se quedan
                  solas tratando de entender qué hacer primero, qué es prioridad
                  y si lo están haciendo bien.
                </p>
                <p className="text-gray-300 font-medium" data-id="element-1710" data-mp="njws6bwi7wf1">
                  Por eso, el siguiente paso recomendado es una llamada corta de
                  implementación.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CALL EXPLANATION */}
        <section className="max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-1711" data-mp="2z78jt4hyxccr">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-8 space-y-8" data-id="element-1712" data-mp="345a0xjvu31ll">
            <div className="text-center space-y-4" data-id="element-1713" data-mp="38vqgpan4mzb4">
              <h2 className="text-xl md:text-2xl font-bold" data-id="element-1714" data-mp="38xl1moyeerf7">
                ¿Querés resultados en serio?
              </h2>
              <p className="text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-1715" data-mp="3dxfu2wxtnp2d">
                El programa que acabás de comprar es increíble. Pero la mayoría
                de las personas consumen contenido… y nunca lo ejecutan al nivel
                que deberían. Y por eso no transforman su vida, su negocio o sus
                resultados.
              </p>
            </div>

            {/* VIP Program Intro */}
            <div className="bg-gray-800/50 p-6 rounded-xl border border-[#7FFF00]/30 space-y-4" data-id="element-1716" data-mp="1xglc213fqqov">
              <h3 className="font-bold text-lg text-[#7FFF00] text-center" data-id="element-1717" data-mp="38r9n1qbf4rs">
                Programa VIP — 6 Meses de Acompañamiento
              </h3>
              <p className="text-gray-300 text-center text-sm" data-id="element-1718" data-mp="3vcaaj2q97e81">
                Estamos abriendo cupos para trabajar con nosotros de forma
                directa:
              </p>
              <ul className="space-y-3" data-id="element-1719" data-mp="80r7momtrnlq">
                {['Llamadas semanales en vivo', 'Coaching directo', 'Estrategia personalizada', 'Acceso a contenido VIP', 'Acompañamiento real', 'Un sistema completo para que avances rápido'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-1720" data-mp="3cg0qlyso7tg4" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-1721" data-mp="3qfa4grtembgx" />
                    {item}
                  </li>)}
              </ul>
              <p className="text-center text-gray-400 text-sm pt-2" data-id="element-1722" data-mp="15n81fjwcnj2q">
                Inversión: alrededor de{' '}
                <strong className="text-white" data-id="element-1723" data-mp="10p6hkwr3nfq7">$2,000</strong>
              </p>
            </div>

            {/* Filter Section */}
            <div className="grid md:grid-cols-2 gap-6" data-id="element-1724" data-mp="2ikgnm9x0d355">
              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700" data-id="element-1725" data-mp="2nlmgc7qo4qeo">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-1726" data-mp="29lbrtbctznwo">
                  <XCircle className="w-5 h-5 text-red-400" data-id="element-1727" data-mp="29noge7d3gwip" />
                  Esta llamada NO es
                </h3>
                <ul className="space-y-3" data-id="element-1728" data-mp="32a96z5lqx4l7">
                  {['Soporte técnico', 'Para preguntas básicas', 'Una consultoría gratis'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-1729" data-mp="36ajcyi9jfv02" data-mpi={i}>
                      <span className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 shrink-0" data-id="element-1730" data-mp="2skpklpytqsll" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="bg-gray-800/50 p-6 rounded-xl border border-[#7FFF00]/30" data-id="element-1731" data-mp="3l94yg967z4vc">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2 text-[#7FFF00]" data-id="element-1732" data-mp="3pzle7zxij2kv">
                  <Check className="w-5 h-5" data-id="element-1733" data-mp="1xzny0uspx39j" />
                  Es para personas que
                </h3>
                <ul className="space-y-3" data-id="element-1734" data-mp="22yievr74khr0">
                  {['Están comprometidas', 'Quieren ir al siguiente nivel', 'Están abiertas a invertir en una mentoría real'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-1735" data-mp="1p127acd3ehxo" data-mpi={i}>
                      <span className="w-1.5 h-1.5 bg-[#7FFF00] rounded-full mt-2 shrink-0" data-id="element-1736" data-mp="1syzyfkqfbe3p" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* SELF QUALIFICATION */}
        <section className="max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-1737" data-mp="15brub64qeb39">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-8 space-y-6" data-id="element-1738" data-mp="1aa31f93n67hs">
            <h3 className="text-xl md:text-2xl font-bold text-center" data-id="element-1739" data-mp="wabs3lo2lfa4">
              Esta llamada es ideal si:
            </h3>

            <div className="space-y-4" data-id="element-1740" data-mp="119ods337ggb4">
              {['Quieres avanzar más rápido', 'No quieres adivinar si lo estás haciendo bien', 'Prefieres claridad antes que prueba y error', 'Sabes que solo tardarías más sin ayuda'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-1741" data-mp="cq365wmyvj0p" data-mpi={i}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center mt-1" data-id="element-1742" data-mp="qot5zk167wsr">
                    <CheckCircle2 className="w-4 h-4 text-[#7FFF00]" data-id="element-1743" data-mp="mosotrmot7i0" />
                  </div>
                  <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-1744" data-mp="10kmr3rsygym5">
                    {item}
                  </p>
                </div>)}
            </div>

            <p className="text-center text-gray-400 pt-4" data-id="element-1745" data-mp="1aaz6l5lwy1lf">
              Si eres de los que ejecuta mejor con feedback, esta llamada es
              para ti.
            </p>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="max-w-2xl mx-auto text-center space-y-6 mb-12 md:mb-16" data-id="element-1746" data-mp="1javxldvrzcjn">
          <div className="space-y-2" data-id="element-1747" data-mp="1efp0wq0xb848">
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-1748" data-mp="c0pwgky1lwxm">
              Agenda tu llamada de implementación ahora
            </h2>
            <p className="text-gray-400" data-id="element-1749" data-mp="h0lwk93md47w">(Los espacios son limitados)</p>
          </div>

          <button onClick={() => setShowSurvey(true)} className="block w-full bg-gradient-to-b from-[#7FFF00] to-[#6FEF00] hover:from-[#6FEF00] hover:to-[#5FDF00] text-black font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#7FFF00]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1750" data-mp="l0w7m069qktm">
            <span className="flex items-center justify-center gap-3" data-id="element-1751" data-mp="zoh6tj00vzw9">
              APLICAR PARA LA LLAMADA VIP
              <ArrowRight className="w-5 h-5" data-id="element-1752" data-mp="14pwr38udm2dl" />
            </span>
          </button>

          <p className="text-center text-yellow-400 text-sm font-medium mt-3" data-id="element-1753" data-mp="18q6xgmm2yusz">
            ⚠️ Solo para alumnos listos para avanzar al siguiente nivel. Cupos
            limitados.
          </p>

          {/* EXPECTATIONS */}
          <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-6 space-y-4" data-id="element-1754" data-mp="3ak6apdirjm8b">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-gray-300" data-id="element-1755" data-mp="330nicgnmqgn2">
              <div className="flex flex-col items-center gap-2" data-id="element-1756" data-mp="2y6j9fruszyjc">
                <Clock className="w-5 h-5 text-[#7FFF00]" data-id="element-1757" data-mp="2t9svpb6h1f13" />
                <span data-id="element-1758" data-mp="2p75zky2rp7y3">Duración: 20–30 minutos</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-1759" data-mp="2p90m2gtot84a">
                <Check className="w-5 h-5 text-[#7FFF00]" data-id="element-1760" data-mp="3lwdma9f4hn3l" />
                <span data-id="element-1761" data-mp="3gyc4drtfnttp">No es obligatoria</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-1762" data-mp="3gyva8a5t6rrd">
                <AlertCircle className="w-5 h-5 text-[#7FFF00]" data-id="element-1763" data-mp="3cvyxh02y9pvc" />
                <span data-id="element-1764" data-mp="37xnpkuw7tpfr">Sin presión de venta</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-1765" data-mp="37zrqd3yti8bt">
              Si no es un buen fit, te lo diremos. Nuestro objetivo es ayudarte
              a avanzar.
            </p>
          </div>
        </section>

        {/* CLOSING */}
        <section className="text-center space-y-6 max-w-xl mx-auto pb-12" data-id="element-1766" data-mp="3kfgc0r4mi9ep">
          <div className="w-16 h-1 bg-gray-700 mx-auto rounded-full" data-id="element-1767" data-mp="3kddd1hlht5xu" />
          <h3 className="text-xl font-medium text-white" data-id="element-1768" data-mp="3p7hitxj0v7xc">
            Gracias por tomar acción.
          </h3>
          <p className="text-gray-300 leading-relaxed" data-id="element-1769" data-mp="3bgcrrjtpznym">
            Las personas que obtienen resultados no son las que saben más, sino
            las que ejecutan con claridad.
          </p>
          <p className="font-bold text-[#7FFF00] text-lg" data-id="element-1770" data-mp="713807g1ve36">
            Nos vemos en la llamada.
          </p>
        </section>
      </main>

      {/* Survey Modal */}
      {showSurvey && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowSurvey(false)} data-id="element-1771" data-mp="3u4818riauflx">
          <div className="bg-gray-900 border border-gray-700 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-1772" data-mp="2ipuh9xqo2kb6">
            <button onClick={() => setShowSurvey(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors z-10 p-1" data-id="element-1773" data-mp="2nmule33yhczn">
              <X className="w-6 h-6" data-id="element-1774" data-mp="2b7397fjojq0w" />
            </button>
            <div className="p-6 pt-12" data-id="element-1775" data-mp="2b8o4569wpaza">
              <iframe src="https://api.leadconnectorhq.com/widget/survey/y25LzbmJtTRp1ZfZ0sY8" style={{
            border: 'none',
            width: '100%',
            minHeight: '600px'
          }} scrolling="no" id="y25LzbmJtTRp1ZfZ0sY8" title="survey" data-id="element-1776" data-mp="2p6csio36n093"></iframe>
            </div>
          </div>
        </div>}

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12 mt-16" data-id="element-1777" data-mp="1rk5obfasj9x9">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1778" data-mp="2680fusd2b88r">
          <div className="mb-6" data-id="element-1779" data-mp="21gs43po9fasf">
            <p className="text-[#7FFF00] font-bold text-lg md:text-xl mb-2" data-id="element-1780" data-mp="21fqjathfz9xi">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-1781" data-mp="1dol6yoapmzry">
            <p data-id="element-1782" data-mp="18pqmzj10b569">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500" data-id="element-1783" data-mp="3dsnpxxvqdym2">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-1784" data-mp="3ijvxeodi39wl">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}